import React from 'react';

import { useParams } from 'react-router-dom';

import ErrorScreen from 'components/shared/ErrorScreen';
import Loader from 'components/shared/Loader';
import { CustomPrivacyPolicyBody } from 'components/shared/TermsAndConds/LocalLegalInfo/CustomPrivacyPolicy';
import useNoIndexMeta from 'hooks/useNoIndexMeta';
import { usePrivacyPolicy } from 'hooks/usePrivacyPolicy';

import s from './index.module.css';

function PrivacyPolicy() {
  useNoIndexMeta();

  const { guestPortalId } = useParams<{ guestPortalId: string }>();
  const { isLoading, failureReason } = usePrivacyPolicy(guestPortalId);

  if (failureReason) {
    return <ErrorScreen status="404_guest" />;
  }

  if (isLoading) {
    return <Loader isFillBlock />;
  }

  return (
    <div className={s.wrapper}>
      <CustomPrivacyPolicyBody />
    </div>
  );
}

export default PrivacyPolicy;
